import { Hash } from '@lyearn/icons';
import { DatabaseFieldTypeEnum } from '@/types/schema';

export const NumberFieldStaticConfig = {
  Icon: Hash,
  type: DatabaseFieldTypeEnum.Number,
  labelKey: 'Database:DataTypes.Number',
};
